<template>
  <div class="wrap-box">
    <div class="view-title">
      <p class="title">{{words.MyPurse}}</p>
    </div>

    <div class="wallet-box">
      <div class="money-box">
        <p class="title">{{user.pay_type ? words.AccountBalanceShare : words.AccountBalanceShare1}}</p>
        <p class="money">{{user.money}}</p>
        <p class="log-btn" @click="$lfy.Jump.open('/wallet-log')">{{words.IncomeRecord}}</p>
      </div>
      <div class="from-box">
        <div class="item-money item">
          <input
            type="number"
            class="input"
            :placeholder="words.ApplicationQuota"
            v-model="FromData.money"
          />
        </div>
        <div class="item-text item">
          <textarea
            class="textarea"
            :placeholder="words.ApplicationDescription"
            v-model="FromData.note"
          ></textarea>
        </div>
        <p class="btn" :class="{dis:user.pay_type}" @click="submit">{{words.submit}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      FromData: {
        money: "",
        note: ""
      }
    };
  },
  mounted() {
    this.GetUserInfo().then(res => {
      this.setUser(res.data);
    });
  },
  methods: {
    ...mapActions(["StaffRecharge", "GetUserInfo", "setUser"]),
    submit() {
      console.log(this.user);
      if (this.user.pay_type) return false;
      if (!this.$lfy.check.checkRate(this.FromData.money)) {
        this.$Message.success("金额需为正整数");
        return false;
      }
      this.StaffRecharge(this.FromData).then(res => {
        if (res.code) {
          this.FromData = {
            money: "",
            note: ""
          };
          this.$Message.success("申请提交成功，请等待企业管理员审核");
        }
      });
    }
  },
  computed: {
    ...mapGetters({
      words: "words",
      user: "user"
    })
  }
};
</script>

<style lang="scss" scoped>
@import "./staff.scss";
</style>